import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import configureStore from "modules/configureStore";
import { setAuthToken } from "api/http";
import { setUserId } from "trackers";

function setAuthTokenAfterPersist() {
  const { token, account } = store.getState().session;
  if (account) {
    setUserId(account.email);
  }
  setAuthToken(token);
}

const { store, persistor } = configureStore();

export default function App({ children }) {
  return (
    <Provider store={store}>
      <PersistGate
        persistor={persistor}
        onBeforeLift={setAuthTokenAfterPersist}
      >
        {children}
      </PersistGate>
    </Provider>
  );
}
